import type { FaireProductEntity } from "../../entity_types/product";

export const p_2r5hkbvw9h: FaireProductEntity = {
  token: "p_2r5hkbvw9h",
  type: "product",
  name: "High Waist Crop Leggings",
  brandToken: "b_6133nhkv31",
  brandName: "ELIETIAN",
  imageUrl:
    "https://cdn.faire.com/fastly/b97f7451fcc4d3da0e3f2a481b2439ccb4266219e6555943df8b423372dece7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28e09aa24f754aea2f696816401e2fdab866674aef83e94ec021020da34f5b9b.jpeg",
    "https://cdn.faire.com/fastly/690731060b4ce674fe8d9cf1328de8ab5ba0abef4d58becfe34235365272491f.jpeg",
    "https://cdn.faire.com/fastly/6639a40c728b3e5ef165cedf17f55740cc5ae4514aabc2e4c0d3b916644d43cd.jpeg",
    "https://cdn.faire.com/fastly/fa59e6ed2790ff91f96838e2052b843aa0fda82b3d45719a942f7958ec5e905a.jpeg",
    "https://cdn.faire.com/fastly/e5ea2a71ab9a5c0ec3be3f31f55a297d67a0aaadb5807f6e0f0cfdeec4d379e5.jpeg",
    "https://cdn.faire.com/fastly/045fa2f7d365d70acd8d205b18ec1784b374c17cb673c73f2788210316cb6649.jpeg",
    "https://cdn.faire.com/fastly/85f34f05902e55c78b73ca66fb07cc1c1820b359c50943e094515dfb7f09bb17.jpeg",
    "https://cdn.faire.com/fastly/b300b96fbd58b0df736cb405cc634ad594d9002247ccd389f8e65c87499497c0.jpeg",
    "https://cdn.faire.com/fastly/38eaa97cc45c340b90f86fd018497950fd09ce43cf8e73146e8d9c89fdca6809.jpeg",
    "https://cdn.faire.com/fastly/4a7fc7d2035a8116aa0b90e741aed9e962f15c47815ccc673352a2cff7b86d67.jpeg",
    "https://cdn.faire.com/fastly/9c1bd8d0f6a5008ee6503c15196d1e949d0248fe70e07b6aa81419f4d206061e.jpeg",
    "https://cdn.faire.com/fastly/e94e3dfaa7e4adffc48ff7270141df18e227d3da7e5f4391caef4f389003adb9.jpeg",
    "https://cdn.faire.com/fastly/a9bceb4a66be2eab33ffda85a01b0ed675f2911cf8de512d9427676bb328a3fe.jpeg",
    "https://cdn.faire.com/fastly/ee8d3e28266c9fb3f02b6ac58277dbbea836b29109768d03574eb171ec8fbb1a.jpeg",
    "https://cdn.faire.com/fastly/e6e270c4ca7e5a4fd39d9b1101f72bc5fe08aad660d6607debc975536b608bf3.jpeg",
    "https://cdn.faire.com/fastly/8f7a6c37617f2d88f6cc72e71475efaeb5934110ebe227d5e6c57e65c752be50.jpeg",
    "https://cdn.faire.com/fastly/9417b25f7c7c6dc66b65326619e047fa8a535d3c6849672cf9e5855473ab477f.jpeg",
    "https://cdn.faire.com/fastly/353a25d24fc039414348348037c8fd16d13b0ec6956eac0cf11a663bb6a16f26.jpeg",
    "https://cdn.faire.com/fastly/502f0fa05795e850dab47bc765fbea5438b9c60048f2faa230a8e72e6cb16073.jpeg",
    "https://cdn.faire.com/fastly/e5bd974b9d75b0f24cc92a1ad8d0848392b1b3d133e5f92b720f5cb35b1e1f9f.jpeg",
    "https://cdn.faire.com/fastly/364e3272ba3781650d1fa91dfbb2e40980f7c5d73529a2614c845baedfc6f207.jpeg",
    "https://cdn.faire.com/fastly/a6b32af9adf8650dea8523f352a9f141f75fd52936c831258378c065a9c2dc17.jpeg",
    "https://cdn.faire.com/fastly/ad506c974535d370c471d980ba5d2ca39e3ace1b6e03d4bea95437253a38185e.jpeg",
    "https://cdn.faire.com/fastly/05df66c29761a2b9fe1cd17af21cca39564e82f445ba72e3bfd0214d3a3fc24c.jpeg",
    "https://cdn.faire.com/fastly/6f4578f307d46dda98acd4777c116d7fa2343afc4291ac49619c8529344f617d.jpeg",
    "https://cdn.faire.com/fastly/816971b2535aa9902c8dee278cde8b842d955b3a4ce76e1f63383873bfce833b.jpeg",
    "https://cdn.faire.com/fastly/c43148e57849b5a79612b03c00266de6b95b98b59d99875e47833ffd0a10bbe3.jpeg",
    "https://cdn.faire.com/fastly/fe6c799d49fa02299401aac9a2f6080ad2da0a16f15a3d4d875ac9e8e96c44ea.jpeg",
    "https://cdn.faire.com/fastly/48fff0f0e38eb8fb48d6c39ff3cabea860a71ca2670cfb0d0381903319759c54.jpeg",
    "https://cdn.faire.com/fastly/0be1e7ab88e2f8f48605ba667794d296572b7c212a855dd0c8af43e2a75e62a1.jpeg",
    "https://cdn.faire.com/fastly/2c9e46bfd2dcb8df0ebd072cc485fbee83da7311650d0863750e71d447d216fd.jpeg",
    "https://cdn.faire.com/fastly/c41f25ef55321a4c60d677843993d714148f2b0fd0a9a06bc1f57548916677ce.jpeg",
    "https://cdn.faire.com/fastly/b890c99d31e4bdc0e467d4ef413ce2c4c144d2ab5af79143736af4348681dc22.jpeg",
    "https://cdn.faire.com/fastly/122b36e1a677d7ca37c2cc4cdd326a88206daa203e928b499dc56726344b915f.jpeg",
    "https://cdn.faire.com/fastly/8ea048743500818da3357f009b01d9f5d8cddc127932af93f4693d0fa2c4b3ad.jpeg",
    "https://cdn.faire.com/fastly/913a17a7d67e1594bb15cb0cfd60c436c96f630ea13c7bdbec2993f77dae2e8e.jpeg",
  ],
  priceDollars: 16,
  description:
    "Experience comfort like never before with ELIETIAN's High Waist Crop Leggings. These leggings are crafted from a luxurious blend of 75% Rayon, 17% Nylon, and 8% Spandex, ensuring a buttery-soft feel and a smoothing finish.  The tummy control waistband offers the perfect amount of comfort and support.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:35.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
